import { useState } from "react";
import styled from "styled-components";
import { AngleDownIcon } from "../../../icons";
import { Button } from "@mui/material";
import { Link } from "react-router";

const WebHeader = () => {
  const [openMenu, setOpenMenu] = useState("");

  const toggleMenu = (menu: string) => {
    setOpenMenu(openMenu === menu ? "" : menu);
  };
  return (
    <Nav className="shadow">
      <Link to="/" className="logo">
        <img src="/images/logo/tms-light.svg" alt="Logo" className="h-8" />
      </Link>
      <div className="nav-links flex gap-6 relative text-white">
        <Link to="/" className="text-gray-700">
          Home
        </Link>
        <Link to="/aboutus" className="text-gray-700">
          About Us
        </Link>

        <div className="relative group  border-gray-300 text-gray-700  hover:bg-white hover:text-indigo-600">
          <button className="inline-flex text-gray-700">
            Flatform <AngleDownIcon className="mt-3 ml-1" />
          </button>

          <div className="absolute top-full p-5 left-0 mt-3 w-[500px] bg-white border  shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all z-50">
            <div>
              <div className="border-b pb-2 mb-3">
                <h2 className="text-black font-medium">Use Cases</h2>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>
                  Carrier TMS
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Freight Broker TMS
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Hybrid TMS
                </a>
              </div>
            </div>
            <div>
              <div className="border-b pb-2 mb-3 mt-4">
                <h2 className="text-black font-medium">Capabilities</h2>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Integrations
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Data Security
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  EDI Integrations
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative group  border-gray-300 text-gray-700  hover:bg-white hover:text-indigo-600">
          <button className="inline-flex text-gray-700">
            Features <AngleDownIcon className="mt-3 ml-1" />
          </button>

          <div className="absolute top-full p-5 left-0 mt-3 w-[500px] bg-white border  shadow-lg opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all z-50">
            <div>
              <div className="border-b pb-2 mb-3">
                <h2 className="text-black font-medium">Carrier Operations</h2>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Dispatch Management
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Fleet Planning
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Load Tracking
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Load Sourcing
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Fleet Management
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Advance CRM
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Driver App
                </a>
              </div>
            </div>
            <div>
              <div className="border-b pb-2 mb-3 mt-4">
                <h2 className="text-black font-medium">Accounting</h2>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Driver / Carrier Pay
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Invoice Automation
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Fuel , Toll, IFTA & Expense
                </a>
              </div>
            </div>
            <div>
              <div className="border-b pb-2 mb-3 mt-4">
                <h2 className="text-black font-medium">Safety</h2>
              </div>
              <div className="grid grid-cols-2 gap-2">
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Fleet Maintenance
                </a>
                <a
                  href="#"
                  className="text-gray-600 hover:text-gray-500 text-sm"
                >
                  <span className="border px-1 py-0.5 rounded mr-1.5 inline-block w-8 text-center">
                    <i className="fa-solid fa-building"></i>
                  </span>{" "}
                  Compliance & Safety
                </a>
              </div>
            </div>
          </div>
        </div>

        <a href="#" className="text-gray-700">
          Resources
        </a>
        <Link to={"/contactus"} className="text-gray-700">
          Contact
        </Link>
      </div>
      <div className="auth-buttons flex gap-2">
        <Link
          to={"signin"}
          className="login text-primary border b-primary rounded px-3 py-1 from-[#a200be] to-[#246BFD] bg-gradient-to-tl bg-clip-text text-transparent"
        >
          Sign In
        </Link>
        <Link
          to="/"
          className="bg-gradient-to-r from-violet-600 to-indigo-600 text-white border b-primary rounded px-3 py-1"
        >
          Get Started
        </Link>
      </div>
    </Nav>
  );
};

export default WebHeader;

const Nav = styled("nav")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 6rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  background: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  .logo {
    font-size: 1.8rem;
    font-weight: 700;
    color: var(--text-primary);
    text-decoration: none;
    letter-spacing: -0.5px;
  }
`;
